<template>
    <div class="fragile-wrap">
        <!--icon button div-->
        <div class="fragile-type" v-if="show">
            <button class="btn btn-outline-secondary border-[#728096] inline-block mr-1 mb-2 px-[7px] py-1 ml-1 text-gray-600" :class="{'active-fragile-btn' : fragileStatus.includes('health')}" @click="fragileTypeClick('health')">
                <HeartIcon class="w-4 h-4" />
                <div class="text-[10px]">สุขภาพ</div>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] inline-block mr-1 mb-2 px-[7px] py-1 text-gray-600" :class="{'active-fragile-btn' : fragileStatus.includes('family')}" @click="fragileTypeClick('family')">
                <HomeIcon class="w-4 h-4" />
                <div class="text-[10px]">ความเป็นอยู่</div>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] inline-block mr-1 mb-2 px-[7px] py-1 text-gray-600" :class="{'active-fragile-btn' : fragileStatus.includes('education')}" @click="fragileTypeClick('education')">
                <BookOpenIcon class="w-4 h-4" />
                <div class="text-[10px]">การศึกษา</div>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] inline-block mr-1 mb-2 px-[7px] py-1 text-gray-600" :class="{'active-fragile-btn' : fragileStatus.includes('occupation')}" @click="fragileTypeClick('occupation')">
                <DollarSignIcon class="w-4 h-4" />
                <div class="text-[10px]">รายได้</div>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] inline-block mr-1 mb-2 px-[7px] py-1 text-gray-600" :class="{'active-fragile-btn' : fragileStatus.includes('accessibility')}" @click="fragileTypeClick('accessibility')">
                <GiftIcon class="w-4 h-4" />
                <div class="text-[10px]">การเข้าถึงบริการภาครัฐ</div>
            </button>
        </div>
        <div class="fragile-type flex items-center" v-else>
            <button class="btn btn-outline-secondary border-[#728096] mr-1 mb-2 px-[7px] ml-1 text-gray-600 t-tooltip btn-tooltip" :class="{'active-fragile-btn' : fragileStatus.includes('health')}" @click="fragileTypeClick('health')">
                <HeartIcon class="w-6 h-6" />
                <span class="t-tooltip-text">สุขภาพ</span>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] mr-1 mb-2 px-[7px] text-gray-600 t-tooltip btn-tooltip" :class="{'active-fragile-btn' : fragileStatus.includes('family')}" @click="fragileTypeClick('family')">
                <HomeIcon class="w-6 h-6" />
                <span class="t-tooltip-text">ความเป็นอยู่</span>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] mr-1 mb-2 px-[7px] text-gray-600 t-tooltip btn-tooltip" :class="{'active-fragile-btn' : fragileStatus.includes('education')}" @click="fragileTypeClick('education')">
                <BookOpenIcon class="w-6 h-6" />
                <span class="t-tooltip-text">การศึกษา</span>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] mr-1 mb-2 px-[7px] text-gray-600 t-tooltip btn-tooltip" :class="{'active-fragile-btn' : fragileStatus.includes('occupation')}" @click="fragileTypeClick('occupation')">
                <DollarSignIcon class="w-6 h-6" />
                <span class="t-tooltip-text">รายได้</span>
            </button>
            <button class="btn btn-outline-secondary border-[#728096] mr-1 mb-2 px-[7px] text-gray-600 t-tooltip btn-tooltip" :class="{'active-fragile-btn' : fragileStatus.includes('accessibility')}" @click="fragileTypeClick('accessibility')">
                <GiftIcon class="w-6 h-6" />
                <span class="t-tooltip-text">การเข้าถึงบริการภาครัฐ</span>
            </button>
        </div>
        <div class="flex items-center text-gray-600 font-bold mb-2">
            ระดับความเปราะบาง
        </div>
        <div class="box p-3 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-3xl font-bold">
            <div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden">
                <button class="btn mr-1 border-0 rounded-full w-10 h-10 p-2 text-white hover:bg-theme-36 bg-theme-36">
                    3
                </button>
            </div>
            <div class="ml-auto">
                <div class="text-custom-member text-md mt-0.5 text-right">
                    {{millionShortNum(data.fg3)}} {{millionShortString(data.fg3)}}
                </div>
            </div>
        </div>
        <div class="box p-3 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-3xl font-bold">
            <div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden">
                <button class="btn mr-1 border-0 rounded-full w-10 h-10 p-2 text-white hover:bg-[#e0af91] bg-[#e0af91]">
                    2
                </button>
            </div>
            <div class="ml-auto">
                <div class="text-custom-member text-md mt-0.5 text-right">
                    {{millionShortNum(data.fg2)}} {{millionShortString(data.fg2)}}
                </div>
            </div>
        </div>
        <div class="box p-3 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-3xl font-bold">
            <div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden">
                <button class="btn mr-1 border-0 rounded-full w-10 h-10 p-2 text-white hover:bg-[#dfd891] bg-[#dfd891]">
                    1
                </button>
            </div>
            <div class="ml-auto">
                <div class="text-custom-member text-md mt-0.5 text-right">
                    {{millionShortNum(data.fg1)}} {{millionShortString(data.fg1)}}
                </div>
            </div>
        </div>
        <div class="box p-3 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-3xl font-bold">
            <div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden">
                <button class="btn mr-1 border-0 rounded-full w-10 h-10 p-2 text-white hover:bg-[#b8e091] bg-[#b8e091]">
                    0
                </button>
            </div>
            <div class="ml-auto">
                <div class="text-custom-member text-md mt-0.5 text-right">
                    <!-- {{statsProblemData?.allstats?.length>0 ? millionShortNum(statsProblemData.allstats[0].prob_family) + millionShortString(statsProblemData.allstats[0].prob_family) : 0}} -->
                    {{millionShortNum(data.fg0)}} {{millionShortString(data.fg0)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { millionShortNum,millionShortString } from "@/utils/format-number"
const fragileStatus = ref([])
const show = ref(true)
const props = defineProps({
    data: Object,
})
const emit = defineEmits([
    "click:dimension"
])
function setWindowSize(){
    if(document.getElementsByClassName('fragile-wrap')[0].clientWidth < 345 ){
        show.value = false
    }
    else{
        show.value = true
    }
}
function fragileTypeClick(evt){
    fragileStatus.value.indexOf(evt) === -1 ? fragileStatus.value.push(evt) : fragileStatus.value.splice(fragileStatus.value.indexOf(evt),1)
    emit("click:dimension",fragileStatus.value)
}
onMounted(()=>{
    window.addEventListener('resize', setWindowSize);
    setWindowSize()
})
</script>

<style lang="scss" scoped>
.box-shadow{
  box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
}
.fragile-type{
    .btn-tooltip{
        flex-grow: 1;
        flex-basis: 0;
    }
}
</style>